import React, { useState } from "react";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";

import useStyles, { StyledCard } from "./StyledComponents/ProfileDonationCardStyles";

export function ProfileDonationDetailCard({ amount, label, Icon, backgroundColor, color }) {
    const classes = useStyles();
    const user = useSelector(state => state.authentication.current_user);
    const currencySymbol = user?.profiles.currency_symbol

    return <StyledCard sx={{ backgroundColor: backgroundColor }}>
        <CardContent>
            {Icon}
            <Box sx={{ color: color }}>
                <Typography className={classes.amount}>
                    {currencySymbol} {amount}
                </Typography>
                <Typography>
                    {label}
                </Typography>
            </Box>
        </CardContent>
    </StyledCard>
}